<template lang="pug">
b-modal#ChooseAdAccountOnboarding(centered hide-footer hide-header button-size="sm" no-close-on-backdrop)
    .modalContent
        .close(@click="hideModal")
            span close
        .title
            span.black Select Ad Account
        .textual.thin(v-if="platform == 'google'") Select every Google Ads account used for this store. The first account you select will be the primary account.
        .textual.thin(v-else) Please choose the Ad Account you use for this store
        .Ad-Accounts-Container
            LocalLoader(v-if="loading")
            template(v-else-if="platform == 'google'")
                label.google-account(v-for="ad in adAccounts" :key="googleAccountKey(ad)" :class="{ selected: isGoogleAccountSelected(ad) }")
                    input(type="checkbox" :checked="isGoogleAccountSelected(ad)" @change="toggleGoogleAccount(ad)")
                    .google-account-details
                        .google-account-name {{ ad.name || ad.id }}
                        .google-account-meta ID: {{ ad.id }}
                            span(v-if="ad.currency")  · {{ ad.currency }}
                    span.primary-account(v-if="isPrimaryGoogleAccount(ad)") Primary
            .input-container(v-else v-for="ad in adAccounts" :key="ad.id" @click="onAdSelected(ad)")
                .textual.thin {{ad.id}}
        .selection-actions(v-if="platform == 'google'")
            span.selection-count {{ selectedGoogleAccounts.length }} selected
            button.button-right(type="button" :disabled="loading || selectedGoogleAccounts.length == 0" @click="selectGoogleAdAccounts") Save selection
        
</template>
    <script>
    
    import { mapActions } from 'vuex'
    export default {
      components: {
    
      },
      data() {
        return {
          adAccounts: [],
          selectedAccount: "",
          platform: "",
          loading: false,
          mode: "general",
          selectedGoogleAccounts: [],
        }
      },
      computed: {
        computedDisabledDates() {
    
    
        }
      },
      methods: {
        ...mapActions(["AddPageError"]),
        launchModal(adAccounts, platform, mode) {
    
          this.adAccounts = adAccounts;
          this.platform = platform
          this.mode = mode
          this.selectedGoogleAccounts = []
    
    
          this.$bvModal.show('ChooseAdAccountOnboarding');
        },
    
    
        hideModal() {
    
          this.loading = false;
          this.$emit('closedAdAccountOnboarding', true);
          this.$bvModal.hide('ChooseAdAccountOnboarding');
    
        },
        googleAccountKey(account) {
          return `${account.id}:${account.parent ?? ""}`
        },
        isGoogleAccountSelected(account) {
          const accountKey = this.googleAccountKey(account)
          return this.selectedGoogleAccounts.some(selected => this.googleAccountKey(selected) == accountKey)
        },
        isPrimaryGoogleAccount(account) {
          return this.selectedGoogleAccounts.length > 0 && this.googleAccountKey(this.selectedGoogleAccounts[0]) == this.googleAccountKey(account)
        },
        toggleGoogleAccount(account) {
          const accountKey = this.googleAccountKey(account)
          const selectedIndex = this.selectedGoogleAccounts.findIndex(selected => this.googleAccountKey(selected) == accountKey)

          if (selectedIndex == -1) {
            this.selectedGoogleAccounts.push(account)
          } else {
            this.selectedGoogleAccounts.splice(selectedIndex, 1)
          }
        },
        selectGoogleAdAccounts() {
          if (this.loading || this.selectedGoogleAccounts.length == 0) {
            return
          }

          this.loading = true
          const adAccount = {
            mode: this.mode,
            adAccounts: this.selectedGoogleAccounts.map(account => ({
              id: account.id,
              parent: account.parent,
            })),
          }

          this.$store.dispatch("userdata/SelectGoogleAdAccount", adAccount)
            .then(data => {
              if (data == "success") {
                this.$emit('adAccountSelected', true)
                this.hideModal()
              } else {
                this.AddPageError({ msg: "Google Connection Failed - Please Retry Again", tag: "error" })
                this.$emit('adAccountSelected', false)
                this.hideModal()
              }
            }).catch(error => {
              this.AddPageError({ msg: error?.response?.data?.error || "Requesting Google failed", tag: "error" })
              this.$emit('adAccountSelected', false)
              this.hideModal()
            })
        },
        onAdSelected(account) {
    
          this.loading = true;
          console.log(account)
          console.log(this.loading)
    
          if (account.id != null) {
            console.log("Ready to update Selection")
    
            if (this.platform == "pinterest") {
    
              var adAccount = {
                adAccountID: account.id,
                currency: account?.currency ?? "",
                mode: this.mode,
              }
    
              this.$store.dispatch("userdata/SelectPinterestAdAccount", adAccount)
                .then(data => {
                  console.log("Ad Accounts updated", data)
                  if (data == "success") {
    
                    this.$emit('adAccountSelected', true);
                    this.hideModal()
    
                  } else {
                    this.AddPageError({ msg: "Pinterest Connection Failed - Please Retry Again", tag: "error" });
    
                    this.$emit('adAccountSelected', false);
                    this.hideModal()
                  }
                }).catch(e => {
                  this.AddPageError({ msg: "Requesting Pinterest failed", tag: "error" });
                  this.$emit('adAccountSelected', false);
                  this.hideModal()
                });
            } else if (this.platform == "facebook") {
    
              console.log("Ready to update Selection")
    
              var adAccount = {
                adAccountID: account.id,
                adAccountID2: account.account_id,
                mode: this.mode,
              }
    
              console.log(adAccount)
              this.$store.dispatch("userdata/SelectFacebookAdAccount", adAccount)
                .then(data => {
                  console.log("Ad Accounts updated", data)
                  if (data == "success") {
    
                    this.$emit('adAccountSelected', true);
                    this.hideModal()
    
                  } else {
                    this.AddPageError({ msg: "Facebook Connection Failed - Please Retry Again", tag: "error" });
    
                    this.$emit('adAccountSelected', false);
                    this.hideModal()
                  }
                }).catch(e => {
                  this.AddPageError({ msg: "Requesting Pinterest failed", tag: "error" });
                  this.$emit('adAccountSelected', false);
                  this.hideModal()
                });
    
            } else if (this.platform == "snapchat") {
    
              var adAccount = {
                adAccountID: account.id2,
                adAccountname: account.id,
                currency: account.currency,
                timezone: account.timezone,
                mode: this.mode,
              }
    
              console.log(adAccount)
              this.$store.dispatch("userdata/SelectSnapchatAdAccount", adAccount)
                .then(data => {
                  console.log("Ad Accounts updated", data)
                  if (data == "success") {
    
                    this.$emit('adAccountSelected', true);
                    this.hideModal()
    
                  } else {
                    this.AddPageError({ msg: "SnpachatConnection Failed - Please Retry Again", tag: "error" });
    
                    this.$emit('adAccountSelected', false);
                    this.hideModal()
                  }
                }).catch(e => {
                  this.AddPageError({ msg: "Requesting Pinterest failed", tag: "error" });
                  this.$emit('adAccountSelected', false);
                  this.hideModal()
                });
    
            } else if (this.platform == "google") {
    
              var adAccount = {
                adAccountID: account.id,
                mode: this.mode,
              }
    
              console.log(adAccount)
              this.$store.dispatch("userdata/SelectGoogleAdAccount", adAccount)
                .then(data => {
                  console.log("Ad Accounts updated", data)
                  if (data == "success") {
    
                    this.$emit('adAccountSelected', true);
                    this.hideModal()
    
                  } else {
                    this.AddPageError({ msg: "SnpachatConnection Failed - Please Retry Again", tag: "error" });
    
                    this.$emit('adAccountSelected', false);
                    this.hideModal()
                  }
                }).catch(e => {
                  this.AddPageError({ msg: "Requesting Google failed", tag: "error" });
                  this.$emit('adAccountSelected', false);
                  this.hideModal()
                });
    
            } else if (this.platform == "tiktok") {
    
              var adAccount = {
                adAccountID: account.id,
                mode: this.mode,
              }
    
              console.log(adAccount)
              this.$store.dispatch("userdata/SelectTiktokAdAccount", adAccount)
                .then(data => {
                  console.log("Ad Accounts updated", data)
                  if (data == "success") {
    
                    this.$emit('adAccountSelected', true);
                    this.hideModal()
    
                  } else {
                    this.AddPageError({ msg: "Connecting TikTok Failed - Please Retry Again", tag: "error" });
    
                    this.$emit('adAccountSelected', false);
                    this.hideModal()
                  }
                }).catch(e => {
                  this.AddPageError({ msg: "Requesting Google failed", tag: "error" });
                  this.$emit('adAccountSelected', false);
                  this.hideModal()
                });
    
            }
          }
    
        },
    
    
      }
    
    }
    </script>
    <style lang="scss" scoped>
    #ChooseAdAccountOnboarding {
    
      .modalContent {
        min-height: 200px;
        display: flex;
        flex-direction: column;
        padding: 10px;
      }
    
      .title {
        .black {
          color: $text-color;
        }
      }
    
      .textual {
        font-size: 14px;
        padding-right: 50px;
      }
    
    
      .Ad-Accounts-Container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: $layoutDefaultMargin;
        overflow: auto;
        max-height: 300px;
      }
    
      .input-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-top: 20px;
        cursor: pointer;
    
      }

      .google-account {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        margin-top: 10px;
        padding: 12px;
        border: 1px solid #dedede;
        border-radius: 6px;
        cursor: pointer;

        &.selected {
          border-color: $text-color;
          background-color: rgba(0, 0, 0, 0.03);
        }

        input {
          flex: 0 0 auto;
        }
      }

      .google-account-details {
        display: flex;
        min-width: 0;
        flex-direction: column;
      }

      .google-account-name {
        font-size: 14px;
        font-weight: 600;
      }

      .google-account-meta,
      .selection-count {
        color: #777;
        font-size: 12px;
      }

      .primary-account {
        margin-left: auto;
        color: $text-color;
        font-size: 12px;
        font-weight: 600;
      }

      .selection-actions {
        display: flex;
        align-items: center;
        margin-top: 20px;
      }
    
      .input-wrapper {
        border: none; // added to remove the default border
        width: 100%; //
        margin-top: 5px;
        margin-bottom: 5px;
      }
    
    
    
      button.button-right {
        margin-left: 10px;
        height: 30px;
        width: 120px;
        background-color: $text-color;
        color: white;
        border-radius: 5px;
        border: none;
        margin-left: auto;

        &:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
    
      }
    
      .close {
        position: absolute;
        right: 20px;
        color: lightgrey;
        cursor: pointer;
        font-weight: 100;
        top: 20px;
    
        &:hover {
          color: black
        }
      }
    
    
    }
    </style>
